export enum ENotifyMethods {
  Email = "Email",
  Push = "Push",
  Sms = "SMS",
  App = "App"
}